import { createClient } from '@supabase/supabase-js'

// Supabase anon key is safe to expose - it's public by design
// Protected by Row Level Security (RLS) policies on the database
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || ''
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseKey) {
  console.warn('Supabase not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseKey)

// Database types
export interface User {
  id: string
  email: string
  created_at: string
  source?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  data?: {
    name?: string
    company?: string
    [key: string]: any
  }
} 